// $FlowFixMe - TS file
import env from 'bench-environment';
// @flow
import type { RequestGeneratorClient } from './types';

const provideUploadsLink = ({
  accounts,
  yearlyData,
  id: clientId,
}: RequestGeneratorClient): string => {
  const hasAccountDocumentsRequest = accounts.some(account =>
    account.monthlyData.some(monthData => monthData.status === 'DATA_REQUESTED'),
  );
  const hasYearlyDataRequest = yearlyData.some(
    yearData =>
      yearData.cpaAdjustment === 'DATA_REQUESTED' ||
      yearData.trialBalanceOrPriorReturn === 'DATA_REQUESTED',
  );
  if (!hasAccountDocumentsRequest && !hasYearlyDataRequest) {
    return '';
  }
  return `\
You can upload these documents here:
${env.location.cwa}/client/${clientId}/accounting/documents\
`;
};

export default provideUploadsLink;
